import { useTranslation } from 'react-i18next'

import { OrderShopsList } from '@widgets/order-shops-list'

import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function ShopStorePage () {
  const { t: p } = useTranslation('personal')
  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <h2 className={styles.root__title}>{p('nav.offline-orders')}</h2>
      </Wrapper>
      <OrderShopsList />
    </div>
  )
}
